import React from "react";
import PropTypes from "prop-types";
import { Avatar as AntdAvatar } from "antd";
import MaterialIcon from "./MaterialIcon";
import api from "../../config/api";

@autobind
/**
 *
 */
export default class Avatar extends React.PureComponent {
  static propTypes = {
    shape: PropTypes.oneOf([
      "circle", "square",
    ]),
    size: PropTypes.oneOf([
      "large", "small", "default",
    ]),
    src: PropTypes.string,
    icon: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node,
    ]),
    text: PropTypes.string,
    style: PropTypes.object,
  };

  static defaultProps = {
    style: {},
  };

  /**
   *
   * @return {*}
   * @private
   */
  _renderChild() {
    const { icon, text } = this.props;

    if (icon) {
      if (String.isString(icon)) {
        return <MaterialIcon name={icon} style={{ left: -4, position: "relative" }} />;
      }

      return icon;
    }

    if (!text) {
      return <MaterialIcon name="account" style={{ left: -4, position: "relative" }} />;
    }

    return text.split(" ")
      .reduce((prev, _text) => {
        if (_text[0]) prev +=' '+ _text[0];

        return prev;
      }, "");
  }

  /**
   *
   * @param {String} [string="jgpr"]
   * @return {String}
   * @static
   * @private
   */
  static _stringToColor(string = "jgpr") {
    const _hash = string.split("")
      .reduce((prev, char) => char.charCodeAt(0) + ((prev << 5) - prev), 0);
    const _c = (_hash & 0x00FFFFFF).toString(16).toUpperCase();

    return `#${"00000".substring(0, 6 - _c.length) + _c}`;
  }

  /**
   * تبدیل آدرس تصویر با حذف v1/ از api.url
   * @param {String} src - آدرس تصویر
   * @return {String} آدرس کامل تصویر
   * @private
   */
  _formatImageUrl(src) {
    if (!src) return src;
    
    // اگر آدرس با Profiles شروع شود
    if (src.startsWith('Profiles/')|| src.startsWith('Signatures/')) {
      // حذف v1/ از api.url اگر وجود داشته باشد
      let baseUrl = api.url;
      if (baseUrl.endsWith('/v1')) {
        baseUrl = baseUrl.substring(0, baseUrl.length - 3);
      } else if (baseUrl.includes('/v1/')) {
        baseUrl = baseUrl.replace('/v1/', '/');
      }
      
      // اطمینان از وجود / در انتهای baseUrl
      if (!baseUrl.endsWith('/')) {
        baseUrl += '/';
      }
          console.log("hdsdfsdfsdttp", `${api.protocol}://${baseUrl}${src}`);

      return `${api.protocol}://${baseUrl}${src}`;
    }

    // اگر آدرس کامل باشد، آن را برگردان
    return src;
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const { shape, size, src, text, style } = this.props;
    
    // فرمت کردن آدرس تصویر
    const imageSrc = this._formatImageUrl(src);
    
    return (
      <AntdAvatar
        className="avatar"
        shape={shape}
        size={size}
        src={imageSrc}
        style={src ? style : { ...style, backgroundColor: Avatar._stringToColor(text) }}
      >
        {this._renderChild()}
      </AntdAvatar>
    );
  }
}
